export default {
	data() {
		return {
			contentGrid: {
				els: {},
				handlerAssignments: [],
			},
		};
	},
	mounted() {
		this.contentGrid.els = {
			tabs: Array.from(this.$el.querySelectorAll('.nav-tabs > .flush > [data-toggle="tab"]')),
			tabContent: Array.from(this.$el.querySelectorAll('.tab-pane')),
		};

		this.contentGrid.els.tabs.forEach((tab) => {
			const matches = tab.href.match(/.*\/#{0,1}(.*)/);
			const tabId = matches && matches[1];

			if (!tabId) {
				return;
			}

			const handler = (event) => {
				event.preventDefault();
				this.contentGrid.els.tabs.forEach(item => item.parentElement.classList.remove('active'));
				this.contentGrid.els.tabContent.forEach(item => item.classList.remove('active'));

				tab.parentElement.classList.add('active');
				const tabContentToBeActivated =
					this.contentGrid.els.tabContent.find(item => (item.id === tabId));

				if (tabContentToBeActivated) {
					tabContentToBeActivated.classList.add('active');
				}
				return false;
			};
			this.contentGrid.handlerAssignments.push({
				el: tab,
				handler,
			});
			tab.addEventListener('click', handler);
		});
	},
	beforeDestroy() {
		this.contentGrid.handlerAssignments.foreach((assignment) => {
			assignment.el.removeEventListener('click', assignment.handler);
		});
	},
};



// WEBPACK FOOTER //
// ./src/mixins/preview/ContentGrid.js